export default "__VITE_ASSET__CHCRuWN8__"